/**
 * @file getDataSource.ts
 * Exports a method that returns the name of a data source for a widget.
 */

/**
 * Helper method that returns the name of a data source for a widget.
 *
 * The Product Selector widget is powered through data in a JSON file. When an
 * instance of the widget is declared, the `data-source="maas360" attribute
 * sets which data source to use in the selector. This method returns that
 * attribute to the React app.
 *
 * If the source is not specified, this app defaults to 'maas360' which
 * contains product information for the cloud database selector.

 *
 * @param {Element} element The DOM element that contains this widget.
 * @return {string} The name of the data source; maas360 or iaas.
 */
export default (element: Element) => {
  if (element && typeof element.getAttribute !== 'undefined') {
    return element.getAttribute('data-source') ?? 'envizi';
  }
  return 'envizi';
};
